import { AsyncThunkAction } from 'actions/actions.types'
import { metaphorSlideBackToProfileInRating } from 'common-constants/metaphor'
import { storeFrontVipPath } from 'components/storefront/StoreFront.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'

export const openStoreFrontVipSliderRollbackAction =
  (): AsyncThunkAction => (dispatch, getState) => {
    const { baseUrl } = getState().systemReducer

    dispatch(
      push(
        mergeAllUrls(
          baseUrl,
          storeFrontVipPath,
          metaphorSlideBackToProfileInRating
        )
      )
    )
  }
